export default __webpack_public_path__ + "static/media/property-default.816f6378.png";